import { useState, useCallback } from 'react';
import { API_URL } from '../utils/api';
import { useAuth } from '../contexts/AuthContext';

export const useSSL = () => {
  const { getAuthHeaders } = useAuth();
  const [websites, setWebsites] = useState([]);
  const [pausedCertificates, setPausedCertificates] = useState([]);
  const [stats, setStats] = useState({
    valid: 0,
    expiringSoon: 0,
    expired: 0,
    total: 0
  });

  const fetchCertificates = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/certificates`, {
        headers: getAuthHeaders()
      });
      
      if (!response.ok) {
        console.error('Authentication failed:', response.status);
        setWebsites([]);
        return;
      }
      
      const data = await response.json();
      
      if (Array.isArray(data)) {
        setWebsites(data);
        const paused = data.filter(cert => cert.is_paused === 1).map(cert => cert.id);
        setPausedCertificates(paused);
      } else {
        console.error('Invalid data format:', data);
        setWebsites([]);
      }
    } catch (error) {
      console.error('Error fetching certificates:', error);
      setWebsites([]);
    }
  }, [getAuthHeaders]);

  const fetchStatistics = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/statistics`, {
        headers: getAuthHeaders()
      });
      
      if (!response.ok) {
        console.error('Authentication failed:', response.status);
        return;
      }
      
      const data = await response.json();
      setStats(data);
    } catch (error) {
      console.error('Error fetching statistics:', error);
    }
  }, [getAuthHeaders]);

  return {
    websites,
    setWebsites,
    pausedCertificates,
    setPausedCertificates,
    stats,
    fetchCertificates,
    fetchStatistics
  };
};
